import {
  CATALOG_SERIAL_CODE_KEY,
  CATALOG_SERIAL_CODE_TIMESTAMP_KEY,
} from 'components/catalogs/libs/catalogSessionStorageKeys';

export const validateSerialCode = (raw: string): string | null => {
  const code = raw.trim().toUpperCase();
  if (!code) {
    return 'シリアルコードを入力してください';
  }

  const defaultMessage =
    'シリアルコードの形式が正しくありません。\n恐れ入りますが、お手元のコードをご確認いただき再度お試しください。';

  const isCorrectLength = code.length === 6 || code.length === 10;
  if (!isCorrectLength) {
    return defaultMessage;
  }

  const isAlphaNumeric = /^[A-Z0-9]+$/.test(code);
  if (!isAlphaNumeric) {
    return 'シリアルコードは半角英数字、大文字で入力してください';
  }

  const invalidChars = ['I', 'L', 'O', '1', '0'];
  for (const char of invalidChars) {
    if (code.includes(char)) {
      return defaultMessage;
    }
  }

  return null;
};

export const saveSerialCodeToSession = (raw: string): void => {
  const code = raw.trim().toUpperCase();
  const errorMessage = validateSerialCode(code);
  if (code && errorMessage === null) {
    sessionStorage.setItem(CATALOG_SERIAL_CODE_KEY, code);
    sessionStorage.setItem(CATALOG_SERIAL_CODE_TIMESTAMP_KEY, Date.now().toString());
  }
};

export const getStoredSerialCodeFromSession = (): string | null => {
  const code = sessionStorage.getItem(CATALOG_SERIAL_CODE_KEY);
  const timestamp = sessionStorage.getItem(CATALOG_SERIAL_CODE_TIMESTAMP_KEY);

  if (code && timestamp) {
    const elapsed = Date.now() - parseInt(timestamp, 10);
    const oneHour = 60 * 60 * 1000;
    if (elapsed < oneHour) {
      return code;
    }
    sessionStorage.removeItem(CATALOG_SERIAL_CODE_KEY);
    sessionStorage.removeItem(CATALOG_SERIAL_CODE_TIMESTAMP_KEY);
  }

  return null;
};
